import { defineMessages } from 'react-intl'

const scope = `modules.expense.features.getExpense.presenters.expenseReportDetailPresenter`

export default defineMessages({
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Failed to load expense report. Please try again.',
  },
})
